interface ProgressBarProps {
  completedPercent: number;
}

function ProgressBar({ completedPercent }: ProgressBarProps) {
  const width = `${completedPercent}%`;
  return (
    <div className="relative h-2 w-40">
      <div className="absolute left-0 top-0 h-2 w-40 rounded-lg bg-gray-200"></div>
      <div
        className="absolute left-0 top-0 h-2 w-40 rounded-lg bg-cyan-500"
        style={{ width }}
      ></div>
    </div>
  );
}

export default ProgressBar;
